import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA , MatDialogRef , MatDialogConfig  } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClindxConfig } from 'src/app/core/classes/clindx-table-config';
import { NpiDialogDto } from 'src/app/core/classes/npi-dialog-dto';
import { PhysicianRegistryColumns } from 'src/app/core/enumerations/clindx-mat-table';
import { OrdersService } from 'src/app/feature/order/Service/order.service';
import { PhysicianService } from 'src/app/shared/services/physician.service';

import { Constants } from '../constants';
import { LoaderService } from '../loader/loader.service';
import { BroadcastService } from '../services/broadcast.service';

@Component({
    selector: 'app-npi-dialog',
    templateUrl: './npi-dialog.component.html',
    styleUrls: ['./npi-dialog.component.scss'],
    standalone: false
})
export class NpiDialogComponent implements OnInit, AfterViewChecked {
  @ViewChild('Actions') actions: TemplateRef<any>;
  public dataSource = new MatTableDataSource<any>();
  dataSourceValue: Subject<any> = new Subject();
  matTableConfig: ClindxConfig;
  public chipList: string[] = [];
  request: NpiDialogDto = new NpiDialogDto();
  private subscriptionList = new Array<Subscription>();
  noteDialogisopen: boolean;
  isScreenSmall: Observable<boolean>;
  filterConfig: MatDialogConfig = {
    width: '260px',
    panelClass: 'search-filter-dialog',
    position: { left: '15%', top: '15%' },
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
    restoreFocus: false
  };
  constructor(
    private physicianService: PhysicianService,
    private cdr: ChangeDetectorRef,
    private broadcastService: BroadcastService,
    @Inject(MAT_DIALOG_DATA) public data: any[], private dialogRef: MatDialogRef<NpiDialogComponent>,
    breakpoints: BreakpointObserver, private loaderService: LoaderService, public orderService: OrdersService) {
    this.noteDialogisopen = true;
    this.isScreenSmall = breakpoints.observe(`(max-width: ${Constants.SMALL_WIDTH_BREAKPOINT}px)`)
      .pipe(map(breakpoint => breakpoint.matches));
  }

  ngOnInit() {
    this.request = {
      first_name: null,
      last_name: null,
      city: null,
      number: null,
      postal_code: null,
      state: null
    };
    this.getPhysicianRegistryDetails();
    this.initializeNpiDialogFilter();
    this.physicianService.npiDialogStatus = true;
    this.dialogRef.afterClosed().subscribe(() => {
      this.physicianService.npiDialogStatus = false;
    });
  }

  ngAfterViewChecked() {
    this.matTableConfig = {
      columnList: PhysicianRegistryColumns,
      pagination: true,
      isResponsive: true,
      hasFilter: true,
      hasStickyHeader: true,
      hasSearch: {
        searchText : this.orderService.isOrderingPhysician ?
          'Ordering Physician' : 'Referring Physician'
      },
      sortState: {
        active: 'firstName',
        direction: 'asc',
        sortType: 'CLIENT',
      }
    };
    this.matTableConfig.columnList[0][`cellTemplate`] = this.actions;
    this.cdr.detectChanges();
  }

  initializeNpiDialogFilter() {
    this.subscriptionList.push(
      this.broadcastService.subscribe().subscribe((message) => {
        if (message.type === Constants.NPI_FILTER_EVENT) {
          this.addFilter(
            message.payload.selectedFilterLabelValue,
            message.payload.filterText
          );
        }
      })
    );
  }

  addFilter(appliedFilterName: string, appliedFilterValue: string) {
    this.loaderService.show();
    const columnConfig = PhysicianRegistryColumns.find(
      (x) =>
        x.columnName.toLocaleUpperCase() ===
        appliedFilterName.toLocaleUpperCase()
    );
    this.removeFilter(appliedFilterName);
    appliedFilterValue =
      typeof appliedFilterValue === typeof ''
        ? (appliedFilterValue).toLowerCase()
        : appliedFilterValue;
    let filterValue: string;
    if (columnConfig) {
      switch (columnConfig.columnName) {
        case 'firstName':
          this.request.first_name = appliedFilterValue.concat('*');
          filterValue = this.request.first_name;
          break;
        case 'lastName':
          this.request.last_name = appliedFilterValue.concat('*');
          filterValue = this.request.last_name;
          break;
        case 'city':
          this.request.city = appliedFilterValue.concat('*');
          filterValue = this.request.city;
          break;
        case 'zipCode':
          this.request.postal_code = appliedFilterValue.concat('*');
          filterValue = this.request.postal_code;
          break;
        case 'stateCode':
          this.request.state = appliedFilterValue;
          filterValue = this.request.state;
          break;
        case 'npiNumber':
          this.request.number = appliedFilterValue;
          filterValue = this.request.number;
          break;
      }
      this.chipList = [
        ...this.chipList,
        `${columnConfig.columnDisplayValue}:"${Array.isArray(filterValue) ? Array.from(new Set(filterValue)).join(', ') : filterValue}"`
      ];
    }
    this.getPhysicianRegistryDetails();
  }

  removeChip(chip) {
    const splittedLabel = chip.trim().split(':');
    const appliedFilter = splittedLabel[0];
    this.removeFilter(
      PhysicianRegistryColumns.find(
        (x) => x.columnDisplayValue === appliedFilter
      ).columnName
    );
    this.getPhysicianRegistryDetails();
  }

  removeFilter(removedFilterName: string) {
    const columnConfig = PhysicianRegistryColumns.find(
      (x) => x.columnName === removedFilterName
    );
    if (columnConfig) {
      this.chipList = this.chipList.filter(
        (x) => x.indexOf(`${columnConfig.columnDisplayValue}:"`) !== 0
      );
      switch (columnConfig.columnName) {
        case 'firstName':
          this.request.first_name = null;
          break;
        case 'lastName':
          this.request.last_name = null;
          break;
        case 'city':
          this.request.city = null;
          break;
        case 'zipCode':
          this.request.postal_code = null;
          break;
        case 'stateCode':
          this.request.state = null;
          break;
        case 'npiNumber':
          this.request.number = null;
          break;
      }
    }
  }

  sendSelectedDetail(element) {
    this.dialogRef.close(element);
  }

  private getPhysicianRegistryDetails() {
    this.physicianService.getPhysicianList(this.request).subscribe((data) => {
      this.dataSource.data = (data) ? data.physicianRegistryDetails : [];
      this.dataSourceValue.next(this.dataSource);
      this.loaderService.hide();
    });
  }

}
